'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'trash';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f1f8';
var svgPathData = 'M152-16l-11.9 0-3.4 11.4-20.6 68.6-116.1 0 0 32 448 0 0-32-116.1 0-20.6-68.6-3.4-11.4-155.9 0zM298.5 64l-149 0 14.4-48 120.2 0 14.4 48zM28.7 144l27.3 368 336 0 27.3-368-32.1 0-24.9 336-276.6 0-24.9-336-32.1 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrash = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;